import React from 'react';

export const RightSideContainer = ({
  style = {
    marginBottom: '32px',
    display: 'flex',
    flexDirection: 'column',
  },
  children,
}) => {
  return <div style={style}>{children}</div>;
};
